module.exports = __webpack_public_path__ + "6a020b64700a4800d40ae0745c082998.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/sofas.png
// module id = 550
// module chunks = 0